"use strict";
exports.__esModule = true;
exports.Skeleton = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var class_names_1 = tslib_1.__importDefault(require("../utils/helpers/class-names"));
var skeleton_style_1 = require("./skeleton.style");
var Skeleton = function (_a) {
    var className = _a.className, _b = _a.shape, shape = _b === void 0 ? 'rectangular' : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.color, color = _d === void 0 ? "primary" : _d, rest = tslib_1.__rest(_a, ["className", "shape", "size", "color"]);
    return (react_1["default"].createElement("div", tslib_1.__assign({ role: "status", className: (0, class_names_1["default"])(className, skeleton_style_1.COLORS[color], size ? skeleton_style_1.SIZES[size] : 'h-fit', (0, skeleton_style_1.SHAPES)({ shape: shape, size: size })) }, rest)));
};
exports.Skeleton = Skeleton;
exports["default"] = exports.Skeleton;
//# sourceMappingURL=skeleton.js.map